import { createSlice } from "@reduxjs/toolkit";

export const GamesSlice = createSlice({
  name: "games",
  initialState: {
    games: [],
  },
  reducers: {
    saveGamesData: (state, action) => {
      state.games = action.payload;
    }
  }
});

export const { saveGamesData } = GamesSlice.actions;
export default GamesSlice.reducer;